exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".menu--7IBfV{padding-left:10px;cursor:pointer}.dropDownMenu--2sAym{top:50px}", ""]);

// Exports
exports.locals = {
	"menu": "menu--7IBfV",
	"dropDownMenu": "dropDownMenu--2sAym"
};